import React from 'react'

const EventEvaluation = () => {
  return <div></div>
}

export default EventEvaluation
